
import http from './http';

export const getRepublics = async() => {
    const res = await http.get("/local/republic")
    return res
}

export const getOblasts = async(id: number) => {
    const res = await http.get("/local/oblast?id_republics=" + id)
    return res
}

export const getRaions = async(id: number) => {
    const res = await http.get("/local/raion?id_oblast=" + id)
    return res
}